/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { edit_btn, toggle_off, toggle_on } from "../../assets/img";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import { get, patch, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import CurrentStepCard from "./CurrentStepCard";
import DragAndDrop from "../../components/Property/DragAndDrop";
import { checkPermission } from "../redux/api/PermissionManager";
import { staticArr } from "../../components/StaticData";

const PropertyDocEdit = () => {
  const isUploading = useRef(false);

  // ---------- Owner document (fixed slots) state ----------
  const [addPopup, setAddPopup] = useState(false);
  const [acceptPopup, setAcceptPopup] = useState(false);
  const [documentStatus, setDocumentStatus] = useState(0);
  const inputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState([]); // owner docs only
  const [popUpData, setPopupData] = useState({
    name: "",
    image: "",
    type: "",
  });

  // ---------- Internal document (free-form add) state ----------
  const [internalPopup, setInternalPopup] = useState(false);
  const [internalDocs, setInternalDocs] = useState([]);
  const [internalData, setInternalData] = useState({
    id: null,
    name: "",
    image: "",
  });
  const internalInputRef = useRef(null);

  // ---------- Common state ----------
  const [draggableImages, setDraggableImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [receptionist, setReceptionist] = useState("");
  const [text, setText] = useState([]);
  const [receptionistOptions, setReceptionistOptions] = useState([]);
  const [popup, setPopup] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [tab, setTab] = useState(1);
  const [editable, setEditable] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const type =
    !checkPermission("CAN-ADD-DOCUMENT_VERIFICATION") &&
    !checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION")
      ? "view"
      : location?.state?.type;
  const id = location?.state?.id;
  const owner_id = location?.state?.owner_id;
  const [selectedReceptionists, setSelectedReceptionists] = useState([]);

  useEffect(() => {
    getReceptionist();
    viewProperty();
  }, []);

  const isPdf = (src) =>
    src instanceof File
      ? src.type === "application/pdf"
      : typeof src === "string" && /\.pdf($|\?|#)/i.test(src);

  // names of the fixed owner slots, used to split owner vs internal docs
  const ownerNames = staticArr.map((d) => d.apiName?.toLowerCase().trim());

  const viewProperty = async () => {
    const res = await get(URLS.PROPERTY_MASTER + id);
    console.log("view property", res);
    if (res?.status === "success") {
      let { documents, images, details, document_verified } = res?.data ?? {};

      let document_arr = (documents || []).map((item) => ({
        id: item?.id,
        name: item?.doc_name,
        image: item?.doc_file_name,
      }));

      // split: owner slots vs internal documents
      const owner_arr = document_arr.filter((d) =>
        ownerNames.includes(d.name?.toLowerCase().trim()),
      );
      const internal_arr = document_arr.filter(
        (d) => !ownerNames.includes(d.name?.toLowerCase().trim()),
      );

      // internal tab images (type 2)
      let images_arr = [];
      (images || []).forEach((item) => {
        if (item?.type === 2) {
          images_arr.push({ ...item, image: item?.image_name });
        }
      });

      let reception = (res?.data?.receptionists ?? [])?.map((item) => ({
        value: item?.id,
        label: item?.name,
        code: item?.code,
      }));

      setSelectedImage(owner_arr);
      setInternalDocs(internal_arr);
      setDraggableImages(images_arr);
      setText(details?.additional_texts || []);
      setReceptionist(reception.length !== 0);
      setSelectedReceptionists(reception);
      setDocumentStatus(document_verified);
    }
  };

  const handleChange = (selected) => {
    setSelectedReceptionists(selected || []);
  };

  // Custom Option with Radio Button
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          key={props.value}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{props.label}</span>
          <div className="">
            <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
              ID: {props.data?.code}
            </span>
            <button
              style={{
                marginLeft: "auto",
                height: "16px",
                width: "16px",
                borderRadius: "50%",
                border: "2px solid #9A36E6",
                display: "inline-block",
                position: "relative",
              }}
            >
              {props.isSelected && (
                <span
                  style={{
                    height: "8px",
                    width: "8px",
                    backgroundColor: "#9A36E6",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
              )}
            </button>
          </div>
        </div>
      </components.Option>
    );
  };

  const handleRemove = (value) => {
    setSelectedReceptionists((prev) =>
      prev.filter((item) => item.value !== value),
    );
  };

  const CustomMultiValue = () => null;

  const handleImageClick = () => {
    inputRef.current.click();
  };

  // ---------- Owner document handlers ----------
  const editDocHandler = (index, file, type) => {
    setAddPopup(true);
    setPopupData({
      ind: index,
      id: file?.id,
      name: file?.name,
      image: file?.image,
      type,
    });
  };

  const handleSubmit = async () => {
    if (!popUpData?.name) {
      toast.error("Enter Document Name");
      return;
    }

    if (!popUpData?.image) {
      toast.error("Enter Document");
      return;
    }

    const payload = new FormData();
    payload.append(popUpData.type, popUpData.image);

    try {
      const hasExistingDocument = Boolean(popUpData?.id);
      const method = hasExistingDocument ? patch : post;
      const url = hasExistingDocument
        ? URLS.PROPERTY_OWNER_DOCUMENT_EDIT + id + "/"
        : URLS.PROPERTY_OWNER_DOCUMENT_ADD + id + "/";

      const res = await method(url, payload);
      console.log("document upload response", res);

      if (res?.status === "success") {
        toast.success(res?.message || "Document uploaded successfully");
        onReset();
        setAddPopup(false);
        await viewProperty();
      }
    } catch (error) {
      console.error("Document upload failed", error);
      toast.error("Failed to upload document");
    }
  };

  const onReset = () => {
    setPopupData({
      name: "",
      image: "",
      type: "",
    });
  };

  // ---------- Internal document handlers ----------
  const addDocHandler = () => {
    if (internalDocs.length >= 10) {
      toast.error("Maximum 10 Documents Allowed");
      return;
    }
    setInternalData({ id: null, name: "", image: "" });
    setInternalPopup(true);
  };

  const editInternalDoc = (file) => {
    setInternalData({ id: file?.id, name: file?.name, image: file?.image });
    setInternalPopup(true);
  };

  const resetInternal = () => {
    setInternalData({ id: null, name: "", image: "" });
    setInternalPopup(false);
  };

  const handleInternalSubmit = async () => {
    if (!internalData?.name?.trim()) {
      toast.error("Enter Document Name");
      return;
    }
    if (!internalData?.image) {
      toast.error("Enter Document");
      return;
    }

    const payload = new FormData();
    if (internalData?.id) {
      payload.append("delete_doc_id", internalData.id);
    }
    payload.append("doc_name", internalData.name);
    payload.append("doc_file", internalData.image);

    try {
      const res = await post(
        URLS.PROPERTY_MASTER + id + "/documents/upload/",
        payload,
      );
      console.log("internal document upload", res);

      if (res?.status === "success") {
        toast.success(res?.message || "Document uploaded successfully");
        resetInternal();
        await viewProperty();
      }
    } catch (error) {
      console.error("Document upload failed", error);
      toast.error("Failed to upload document");
    }
  };

  // ---------- Text handlers ----------
  const handleAddText = () => {
    setText((prev) => [...prev, { title: "", description: "" }]);
  };
  const handleChangeText = (index, value) => {
    setText((prev) => prev.map((item, i) => (i === index ? value : item)));
  };
  const handleTextDelete = (index) => {
    setText((prev) => prev.filter((_, i) => i !== index));
  };

  const getReceptionist = async () => {
    const res = await get(URLS.RECEPTIONIST_OVERALL + owner_id + "/");
    if (res?.status === "success") {
      let tempList = res?.data?.map((item) => ({
        value: item?.id,
        label: item?.name,
        code: item?.code,
      }));
      setReceptionistOptions(tempList);
    }
  };

  const hasInternalContent =
    internalDocs.length > 0 ||
    draggableImages.length > 0 ||
    text.some((t) => t?.title?.trim() || t?.description?.trim());

  const handleFimalSubmit = async () => {
    if (isUploading.current) {
      return;
    }

    if (
      text.length === 0 &&
      draggableImages.length === 0 &&
      internalDocs.length === 0
    ) {
      toast.error("Please upload any one of the Feild...");
      return;
    }

    isUploading.current = true;

    try {
      const payload = new FormData();
      payload.append("additional_texts", JSON.stringify(text));

      if (receptionist) {
        payload.append(
          "receptionist_ids",
          JSON.stringify(selectedReceptionists?.map((item) => item.value)),
        );
      }

      let positions_list = [];
      draggableImages?.forEach((img, ind) => {
        payload.append("property_images", img?.image);
        positions_list.push(ind + 1);
      });

      payload.append("deleted_image_ids", deletedImages);
      payload.append(
        "property_images_position",
        JSON.stringify(positions_list),
      );

      const res = await post(
        URLS.PROPERTY_MASTER + id + "/documents/upload/",
        payload,
      );
      console.log("docement upload", res);

      if (res?.status === "success") {
        toast.success(res?.message);
        navigate("/propertie-mmc-edit", {
          state: {
            type: "edit",
            current_position: "mmc",
            id: id,
            owner_id: owner_id,
          },
          replace: true,
        });
      }
    } catch (error) {
      console.error("Upload failed", error);
      toast.error("An error occurred during submission.");
    } finally {
      isUploading.current = false;
    }
  };

  // ---------- Accept / Reject ----------
  const handleAccept = async () => {
    console.log("selectedImage", selectedImage);
    if (selectedImage?.length < 4) {
      toast.error("kindly upload all the images to proceed");
      return;
    }
    let res = await put(URLS.PROPERTY_OWNER_DOCUMENT_ACTION + id + "/", {
      document_verified: 1,
    });
    if (res?.status === "success") {
      toast.success(res?.message);
      setAcceptPopup(false);
      setTab(2);
    }
  };

  const handleReject = async () => {
    if (!rejectReason.trim()) {
      toast.error("Kindly enter the reason to proceed");
      return;
    }
    let payload = {
      document_verified: 0,
      reject_reason: rejectReason,
    };
    let res = await put(
      URLS.PROPERTY_OWNER_DOCUMENT_ACTION + id + "/",
      payload,
    );
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate("/properties-rejected");
    }
  };

  const handleSkip = async () => {
    let url = URLS.PROPERTY_DOCUMENT_SKIP + id + "/";
    let res = await put(url);
    if (res?.status === "success") {
      toast.success(res?.message);
      setTab(2);
    }
  };

  const canReview = !editable && [0, 2, 3].includes(documentStatus);
  const hasImages = selectedImage.length > 0;

  const btnBase = "f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 w-30";

  return (
    <div>
      <Topbar header={"Properties"} subHead={"Verification"} />
      <div>
        <CurrentStepCard />

        {[
          { id: 1, name: "Owner Document" },
          { id: 2, name: "Internal Document" },
        ].map(({ id, name }) => {
          return (
            <button
              key={id}
              className={`mb-2 mt-4 me-5 f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                tab === id ? "active-btn1" : "inactive-btn"
              }`}
              onClick={() => setTab(id)}
            >
              {name}
            </button>
          );
        })}

        {/* ======================= TAB 2 : header + document list ======================= */}
        {tab === 2 && (
          <>
            <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mt-4 red">
              Maximum 10 Documents Allowed
            </p>

            <p
              onClick={addDocHandler}
              className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 green mb-4 pointer"
            >
              +Add Document
            </p>

            {internalDocs.length > 0 && (
              <div className="d-flex flex-wrap gap-5 pb-5">
                {internalDocs.map((file) => (
                  <div key={file.id} className="col-md-5">
                    <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      {file.name}
                    </p>
                    <p
                      onClick={() => editInternalDoc(file)}
                      className="doc-input pointer"
                    >
                      {isPdf(file.image) ? `${file.name}.pdf` : file.name}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* ======================= TAB 1 : owner documents ======================= */}
        {tab == 1 && (
          <>
            <div style={{ borderBottom: "2px solid #D9D9D9" }}>
              <div className="d-flex ac-je">
                {!editable && [1, 2, 3].includes(documentStatus) && (
                  <img
                    onClick={() => setEditable(true)}
                    src={edit_btn}
                    style={{
                      height: "50px",
                      width: "100px",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
              <div className="mt-3 pb-5">
                <div className="d-flex flex-wrap gap-5 pb-5 mt-3">
                  {staticArr.map((documentType) => {
                    const fileIndex = selectedImage?.findIndex(
                      (item) =>
                        item?.name?.toLowerCase().trim() ===
                        documentType.apiName?.toLowerCase().trim(),
                    );

                    const file =
                      fileIndex !== -1 ? selectedImage?.[fileIndex] : null;

                    return (
                      <div key={documentType.type} className="col-md-5">
                        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                          {documentType.label}
                        </p>

                        <div
                          onClick={() => {
                            if (!editable) return;

                            editDocHandler(
                              fileIndex !== -1 ? fileIndex : null,
                              file || {
                                name: documentType.apiName,
                                type: documentType.type,
                              },
                              documentType.type,
                            );
                          }}
                          className="doc-input pointer"
                        >
                          {file?.image ? (
                            isPdf(file.image) ? (
                              <div
                                style={{
                                  position: "relative",
                                  height: "200px",
                                }}
                              >
                                <iframe
                                  src={`${file.image}#toolbar=0&navpanes=0&view=FitH`}
                                  title={documentType.label}
                                  style={{
                                    width: "100%",
                                    height: "200px",
                                    border: 0,
                                    // in edit mode let clicks reach the tile so the edit popup opens;
                                    // in view mode allow scrolling inside the PDF
                                    pointerEvents: editable ? "none" : "auto",
                                  }}
                                />
                                <a
                                  href={file.image}
                                  target="_blank"
                                  rel="noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                  className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14"
                                  style={{
                                    position: "absolute",
                                    top: 6,
                                    right: 6,
                                    background: "#ae55f5",
                                    padding: "2px 8px",
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    color: "white",
                                  }}
                                >
                                  Open PDF
                                </a>
                              </div>
                            ) : (
                              <img
                                src={file.image}
                                alt={documentType.label}
                                style={{
                                  width: "100%",
                                  height: "200px",
                                  objectFit: "contain",
                                }}
                              />
                            )
                          ) : editable ? (
                            // EDIT MODE + empty slot -> upload placeholder
                            <div
                              className="d-flex ac-jc"
                              style={{
                                height: "200px",
                                border: "1px dashed #ccc",
                              }}
                            >
                              <CloudUploadRoundedIcon />
                              <span>Upload {documentType.label}</span>
                            </div>
                          ) : (
                            // NON-EDIT MODE + empty slot -> "None"
                            <div
                              className="d-flex ac-jc"
                              style={{
                                height: "200px",
                                border: "1px dashed #ccc",
                                color: "#888",
                              }}
                            >
                              No Image
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="d-flex ac-jb mt-4">
              {editable ? (
                <>
                  <button
                    onClick={() => setEditable(null)}
                    className={`reject-btn ${btnBase}`}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => setEditable(null)}
                    className={`accept-btn ${btnBase}`}
                  >
                    Save
                  </button>
                </>
              ) : (
                canReview && (
                  <>
                    {hasImages && (
                      <>
                        <button
                          onClick={() => setPopup(true)}
                          className={`reject-btn ${btnBase}`}
                        >
                          Reject
                        </button>
                        <button
                          onClick={() => setAcceptPopup(true)}
                          className={`accept-btn ${btnBase}`}
                        >
                          Accept
                        </button>
                      </>
                    )}
                    <button
                      onClick={handleSkip}
                      className={`skip-btn ${btnBase}`}
                    >
                      Skip
                    </button>
                  </>
                )
              )}
            </div>

            {/* Owner document upload popup */}
            {addPopup && (
              <div className="img-popup-design">
                <div className="img-popup">
                  <div className="d-flex ac-je">
                    <CloseSharpIcon
                      onClick={() => {
                        setAddPopup(false);
                        onReset();
                      }}
                      className="pointer"
                    />
                  </div>
                  <div className="">
                    <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                      Name
                    </p>
                    <input
                      className="doc-input"
                      name="email"
                      value={popUpData?.name}
                      readOnly
                      type="text"
                      placeholder="Document Name"
                    />
                  </div>
                  <div className="d-flex ae-jb px-2 mt-4">
                    <div className="w-60">
                      <div className=" w-100 d-flex ac-jb">
                        <div className="position-relative w-100">
                          <div className=" w-100">
                            <div>
                              <div className="d-flex ae-js gap-1">
                                {popUpData?.image && (
                                  <button
                                    className="view-btn d-flex gap-2 "
                                    onClick={() =>
                                      window.open(
                                        typeof popUpData?.image === "string"
                                          ? popUpData?.image
                                          : URL.createObjectURL(
                                              popUpData?.image,
                                            ),
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                )}
                              </div>
                              <input
                                style={{
                                  position: "absolute",
                                  width: "100px",
                                  height: "100px",
                                  left: "0px",
                                  top: "0px",
                                }}
                                type="file"
                                hidden
                                name="myImage"
                                accept="application/pdf,image/*"
                                ref={inputRef}
                                onChange={(e) =>
                                  setPopupData((pre) => ({
                                    ...pre,
                                    image: e.target.files[0],
                                  }))
                                }
                              />
                              <button
                                className="submit-btn d-flex gap-2 mt-1 "
                                onClick={handleImageClick}
                              >
                                <CloudUploadRoundedIcon /> Upload
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION") && (
                      <button
                        onClick={handleSubmit}
                        className="submit-btn f2 w-40"
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {acceptPopup && (
              <div className="img-popup-design">
                <div className="img-popup">
                  <p className="f3 mt-4">
                    Are you sure you want to Accept the document?
                  </p>
                  <div className="d-flex ac-jb px-2 mt-5">
                    <button
                      onClick={() => setAcceptPopup(false)}
                      className="add-btn w-40"
                    >
                      No
                    </button>
                    <button onClick={handleAccept} className="back-btn f2 w-40">
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {/* Reject popup */}
        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <div className="d-flex ac-jb  mb-4">
                <p className="f3 text-start fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                  Reason To Reject
                </p>
                <CloseSharpIcon
                  onClick={() => {
                    setPopup(false);
                    setRejectReason("");
                  }}
                  className="pointer"
                />
              </div>
              <textarea
                style={{ minHeight: "160px", maxHeight: "300px" }}
                placeholder="Reason"
                className="input-box"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                id=""
              ></textarea>
              <div className="d-flex ac-je px-2 mt-5">
                <button onClick={handleReject} className="submit-btn f2 w-40">
                  Ok
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ======================= TAB 2 : images, text, receptionist ======================= */}
        {tab === 2 && (
          <>
            <div
              style={{
                borderBottom: "2px solid #D9D9D9",
                paddingBottom: "20px",
                marginTop: "20px",
              }}
            >
              <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  my-4 pointer d-flex ">
                <span>Upload Image</span>(Optional)
                <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red center mt-2 ms-3">
                  Max Upload Size : 5MB and Banner Size 1200px 700px, Max 5
                  image*
                </p>
              </p>
              <DragAndDrop
                edit={type !== "view"}
                draggableImages={draggableImages}
                setDraggableImages={setDraggableImages}
                setDeletedImages={setDeletedImages}
              />
            </div>
            <p
              onClick={handleAddText}
              className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  my-4 pointer"
            >
              <span className="green">+Add Text </span>(Optional)
            </p>
            <div className="">
              {text.map((item, ind) => {
                return (
                  <div key={ind} className="w-100 mt-5">
                    <div className="d-flex ac-jb">
                      <input
                        className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 gray input-border w-30 "
                        placeholder="Text"
                        value={item?.title}
                        onChange={(e) => {
                          handleChangeText(ind, {
                            ...item,
                            title: e.target.value,
                          });
                        }}
                      />
                      <CloseSharpIcon
                        onClick={() => handleTextDelete(ind)}
                        className="pointer gray"
                      />
                    </div>
                    <div className="d-flex ae-jb input-border p-1">
                      <textarea
                        style={{ maxHeight: "100px" }}
                        value={item?.description}
                        onChange={(e) => {
                          handleChangeText(ind, {
                            ...item,
                            description: e.target.value,
                          });
                        }}
                        placeholder="Write Here...."
                        className="border-0 mb-3 w-100"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="d-flex ac-js gap-3 mt-5">
              <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                Receptionist
              </p>
              <button className="cust-btn">
                <img
                  onClick={() => {
                    if (receptionistOptions.length === 0) {
                      toast.error("No Receptionist Available");
                      return;
                    }
                    setReceptionist(!receptionist);
                  }}
                  src={receptionist ? toggle_on : toggle_off}
                  className="roles-icon pointer"
                  alt=""
                />
              </button>
            </div>
            {receptionist && (
              <div className={" mb-5  col-md-4 "}>
                <p className=" f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 sec mt-4">
                  Add Receptionist
                </p>

                <div>
                  <Select
                    options={receptionistOptions}
                    value={selectedReceptionists}
                    onChange={handleChange}
                    placeholder="Select Receptionist"
                    isMulti
                    isSearchable
                    isClearable={false}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option: CustomOption,
                      MultiValue: CustomMultiValue, // hides inside select
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor: "#ccc",
                        minHeight: "40px",
                      }),
                    }}
                  />

                  {/* Selected items OUTSIDE the select box */}
                  {selectedReceptionists.length > 0 && (
                    <div style={{ marginTop: "10px" }}>
                      {selectedReceptionists.map((person) => (
                        <div
                          key={person.value}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "6px",
                            padding: "6px 10px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                          }}
                        >
                          <span>{person.label}</span>
                          <div className="">
                            <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
                              ID: {person.code}
                            </span>
                            <button
                              onClick={() => handleRemove(person.value)}
                              style={{
                                marginLeft: "auto",
                                height: "16px",
                                width: "16px",
                                borderRadius: "50%",
                                border: "2px solid #9A36E6",
                                display: "inline-block",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  height: "8px",
                                  width: "8px",
                                  backgroundColor: "#9A36E6",
                                  borderRadius: "50%",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                }}
                              />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Internal document add / edit popup (rendered on tab 2) */}
            {internalPopup && (
              <div className="img-popup-design">
                <div className="img-popup">
                  <div className="d-flex ac-je">
                    <CloseSharpIcon
                      onClick={resetInternal}
                      className="pointer"
                    />
                  </div>
                  <div className="">
                    <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                      Name
                    </p>
                    <input
                      className="doc-input"
                      value={internalData.name}
                      onChange={(e) =>
                        setInternalData((p) => ({
                          ...p,
                          name: e.target.value,
                        }))
                      }
                      type="text"
                      placeholder="Document Name"
                    />
                  </div>
                  <div className="d-flex ae-jb px-2 mt-4">
                    <div className="w-60">
                      <div className="d-flex ae-js gap-1">
                        <p
                          className="bg-gray1 white rounded d-flex ac-jc"
                          style={{ height: "50px", width: "60%" }}
                        >
                          {typeof internalData.image === "string" &&
                          internalData.image
                            ? internalData.name + ".pdf"
                            : internalData.image?.name || "No file chosen"}
                        </p>
                        {internalData.image && (
                          <button
                            className="view-btn d-flex gap-2 mt-1"
                            onClick={() =>
                              window.open(
                                typeof internalData.image === "string"
                                  ? internalData.image
                                  : URL.createObjectURL(internalData.image),
                              )
                            }
                          >
                            View
                          </button>
                        )}
                      </div>
                      <input
                        type="file"
                        hidden
                        accept="application/pdf,image/*"
                        ref={internalInputRef}
                        onChange={(e) =>
                          setInternalData((p) => ({
                            ...p,
                            image: e.target.files[0],
                          }))
                        }
                      />
                      <button
                        className="submit-btn d-flex gap-2 mt-1"
                        onClick={() => internalInputRef.current.click()}
                      >
                        <CloudUploadRoundedIcon /> Upload
                      </button>
                    </div>
                    {checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION") && (
                      <button
                        onClick={handleInternalSubmit}
                        className="submit-btn f2 w-40"
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {tab === 2 && (
        <>
          {checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION") && (
            <div className="d-flex ac-je mt-5">
              <button
                onClick={handleFimalSubmit}
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
                disabled={!hasInternalContent}
                style={{
                  opacity: hasInternalContent ? 1 : 0.5,
                  cursor: hasInternalContent ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PropertyDocEdit;
